export default "__VITE_ASSET__Dchh4BWo__"